// @ts-nocheck
import React from "react";
import SharedSelect from "../SharedSelect";

const DISTANCE_OPTIONS = [5, 10, 25, 50, 100, 250, 500];
const DATE_OPTIONS = [
  { value: "today", label: "Today" },
  { value: "this_week", label: "This Week" },
  { value: "this_month", label: "This Month" },
  { value: "custom", label: "Custom" },
];
const GAME_OPTIONS = ["Pokemon", "One Piece", "MTG", "Yu-Gi-Oh", "Lorcana"];
const EVENT_TYPES = [
  { value: "CONVENTION", label: "Convention" },
];

export default function FiltersSheet({
  isOpen,
  filters,
  onClose,
  onUpdate,
  onClear,
  onApply,
}) {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 8 }, (_, index) => currentYear + index - 1);

  const toggleArrayValue = (key, value) => {
    const current = filters[key];
    const next = current.includes(value)
      ? current.filter((item) => item !== value)
      : [...current, value];
    onUpdate({ ...filters, [key]: next });
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="filters-overlay" role="dialog" aria-modal="true">
      <div className="filters-sheet">
        <div className="filters-header">
          <h3>Filters</h3>
          <button type="button" className="icon-button" onClick={onClose} aria-label="Close filters">
            Close
          </button>
        </div>

        <div className="filters-section">
          <h4>Distance</h4>
          <div className="chip-group">
            {DISTANCE_OPTIONS.map((distance) => (
              <button
                type="button"
                key={distance}
                className={`chip ${filters.distance === distance ? "active" : ""}`}
                onClick={() => onUpdate({ ...filters, distance })}
              >
                {distance} miles
              </button>
            ))}
          </div>
        </div>

        <div className="filters-section">
          <h4>Date range</h4>
          <div className="chip-group">
            {DATE_OPTIONS.map((option) => (
              <button
                type="button"
                key={option.value}
                className={`chip ${filters.dateRange === option.value ? "active" : ""}`}
                onClick={() => onUpdate({ ...filters, dateRange: option.value })}
              >
                {option.label}
              </button>
            ))}
          </div>
          {filters.dateRange === "custom" && (
            <div className="date-range-inputs">
              <label>
                Start
                <input
                  type="date"
                  value={filters.customStart || ""}
                  onChange={(event) =>
                    onUpdate({ ...filters, customStart: event.target.value })
                  }
                />
              </label>
              <label>
                End
                <input
                  type="date"
                  value={filters.customEnd || ""}
                  onChange={(event) =>
                    onUpdate({ ...filters, customEnd: event.target.value })
                  }
                />
              </label>
            </div>
          )}
          <div className="date-range-inputs">
            <label>
              Month
              <SharedSelect
                value={filters.month || ""}
                onChange={(event) =>
                  onUpdate({
                    ...filters,
                    month: event.target.value ? Number(event.target.value) : undefined,
                  })
                }
              >
                <option value="">Any month</option>
                <option value="1">January</option>
                <option value="2">February</option>
                <option value="3">March</option>
                <option value="4">April</option>
                <option value="5">May</option>
                <option value="6">June</option>
                <option value="7">July</option>
                <option value="8">August</option>
                <option value="9">September</option>
                <option value="10">October</option>
                <option value="11">November</option>
                <option value="12">December</option>
              </SharedSelect>
            </label>
            <label>
              Year
              <SharedSelect
                value={filters.year || ""}
                onChange={(event) =>
                  onUpdate({
                    ...filters,
                    year: event.target.value ? Number(event.target.value) : undefined,
                  })
                }
              >
                <option value="">Any year</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </SharedSelect>
            </label>
          </div>
        </div>

        <div className="filters-section">
          <h4>Game type</h4>
          <div className="chip-group">
            {GAME_OPTIONS.map((game) => (
              <button
                type="button"
                key={game}
                className={`chip ${filters.games.includes(game) ? "active" : ""}`}
                onClick={() => toggleArrayValue("games", game)}
              >
                {game}
              </button>
            ))}
          </div>
        </div>

        <div className="filters-section">
          <h4>Event type</h4>
          <div className="chip-group">
            {EVENT_TYPES.map((type) => (
              <button
                type="button"
                key={type.value}
                className={`chip ${filters.eventTypes.includes(type.value) ? "active" : ""}`}
                onClick={() => toggleArrayValue("eventTypes", type.value)}
              >
                {type.label}
              </button>
            ))}
          </div>
        </div>

        <div className="filters-actions">
          <button type="button" className="btn-secondary" onClick={onClear}>
            Clear all
          </button>
          <button type="button" className="btn-primary" onClick={onApply}>
            Apply
          </button>
        </div>
      </div>
    </div>
  );
}
